// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
exports.push([module.id, "@import url(https://unpkg.com/bootstrap@4.1.0/dist/css/bootstrap.min.css);"]);
// Module
exports.push([module.id, "\r\n/* You can add global styles to this file, and also import other style files */\r\n", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":";AAAA,8EAA8E","file":"styles.css","sourcesContent":["/* You can add global styles to this file, and also import other style files */\r\n@import url(https://unpkg.com/bootstrap@4.1.0/dist/css/bootstrap.min.css)\r\n"]}]);
// Exports
module.exports = exports;
